export default "__VITE_ASSET__CiQoNAGu__";